<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-unidademedidaarea') {
            next({ name: 'agro-unidademedidaarea-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-unidademedidaarea') {
            this.$router.push({ name: 'agro-unidademedidaarea-list' });
        }
    },
};
</script>
